module.exports = __webpack_public_path__ + "b4661eafc29b03e8382e4dc638611f47.png";